import React from "react";

const Contact = () => {
  return (
    <div className="bg-containx-navy text-white min-h-screen max-w-screen p-4 sm:p-6 flex flex-col">
      <section className="w-full max-w-5xl mx-auto p-4 sm:p-6 flex-grow">
        <h1 className="text-3xl font-bold mb-6 text-center">Contact Us</h1>

        <p className="mb-8">
          We’re here to help! Reach out via call, text, or email with your
          questions or inquiries.
        </p>
        <p className="mb-8">
          Schedule an appointment today or come on in during our opening hours
          to explore our sample collection and find the perfect fit for your
          business needs!
        </p>

        {/* Contact Info Cards */}
        <div className="flex flex-col sm:flex-row justify-center gap-6 mb-8">
          {/* Email Card */}
          <div className="flex-1 bg-containx-beige text-containx-navy p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-semibold mb-4">Email</h2>
            <p>
              <a
                href="mailto:sales@containx.co"
                className="text-containx-navy hover:underline"
              >
                sales@containx.co
              </a>
            </p>
          </div>

          {/* Phone Card */}
          <div className="flex-1 bg-containx-beige text-containx-navy p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-semibold mb-4">Phone</h2>
            <p>
              <a
                href="tel:+13019698766"
                className="text-containx-navy hover:underline"
              >
                +1 (301) 969-8766
              </a>
            </p>
          </div>

          {/* Address Card */}
          <div className="flex-1 bg-containx-beige text-containx-navy p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-semibold mb-4">Address</h2>
            <p>
              <a
                href="https://www.google.com/maps/place/7377+Washington+Blvd+%23107,+Elkridge,+MD+21075"
                target="_blank"
                rel="noopener noreferrer"
                className="text-containx-navy hover:underline"
              >
                7377 Washington Blvd Ste 107, <br />
                Elkridge, MD 21075
              </a>
            </p>
          </div>
        </div>

        {/* Hours Card */}
        <div className="flex-1 bg-containx-beige text-containx-navy p-6 rounded-lg shadow-lg text-center mb-8">
          <h2 className="text-xl font-semibold mb-4">Hours</h2>
          <div className="flex justify-center">
            <table class="table-auto text-left [&_:is(th,td):where(:nth-child(1))]:font-bold [&_:is(th,td):where(:nth-child(2))]:text-right border-separate border-spacing-x-4 md:border-spacing-x-24">
              <tbody>
                <tr>
                  <td>Monday</td>
                  <td>10AM - 5PM</td>
                </tr>
                <tr>
                  <td>Tuesday</td>
                  <td>10AM - 5PM</td>
                </tr>
                <tr>
                  <td>Wednesday</td>
                  <td>10AM - 5PM</td>
                </tr>
                <tr>
                  <td>Thursday</td>
                  <td>10AM - 5PM</td>
                </tr>
                <tr>
                  <td>Friday</td>
                  <td>10AM - 5PM</td>
                </tr>
                <tr>
                  <td>Saturday</td>
                  <td>10AM - 4PM</td>
                </tr>
                <tr>
                  <td>Sunday</td>
                  <td>Closed</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Google Map */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4 text-center">
            Our Location
          </h2>
          <div className="relative w-full h-64">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3092.7048535548643!2d-76.76715592404955!3d39.18142997166482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7e105e691b82f%3A0x753a837e2d23ae07!2sContainX!5e0!3m2!1sen!2sus!4v1739198323972!5m2!1sen!2sus"
              title="containx-location"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center pt-8">
          <a
            href="/"
            className="bg-containx-navy text-white font-semibold px-6 py-3 rounded-lg shadow-lg hover:bg-containx-beige hover:text-containx-navy transition duration-300"
          >
            Return to Home
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
